import React from "react";
import { useI18nStore } from "../../stores/i18nStore";
import { Language } from "../../types/i18n";
import { Globe } from "lucide-react";
import { log } from "@/lib/log";

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useI18nStore();

  const languages = [
    { code: "en" as Language, name: "English" },
    { code: "de" as Language, name: "Deutsch" },
    { code: "fr" as Language, name: "Français" },
    { code: "es" as Language, name: "Español" },
    { code: "pt" as Language, name: "Português" },
  ];

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const langCode = e.target.value as Language;
    log.debug("🌍 Language changed to:", langCode);
    setLanguage(langCode);
    log.debug("✅ Language set to:", langCode);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        width: "100%",
      }}
    >
      <Globe
        style={{
          width: "18px",
          height: "18px",
          color: "var(--ui-text-muted)",
          flexShrink: 0,
        }}
      />
      <select
        aria-label="Language"
        value={language}
        onChange={handleLanguageChange}
        style={{
          width: "100%",
          padding: "10px 12px",
          background: "var(--ui-field)",
          border: "1px solid var(--ui-line)",
          borderRadius: "12px",
          fontSize: "14px",
          color: "var(--ui-text-body)",
          outline: "none",
          cursor: "pointer",
          transition: "all 0.2s",
          appearance: "none",
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
          paddingRight: "36px",
        }}
        onFocus={(e) => (e.target.style.borderColor = "var(--ui-link)")}
        onBlur={(e) => (e.target.style.borderColor = "var(--ui-line)")}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
